<script setup lang="ts">

import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import BaseLinkButton from '@/components/base/BaseLinkButton.vue'
import { useDailyTransactionTask } from '@/composables/game/tasks'
import ConnectedWallet from '@/components/ConnectedWallet.vue'

defineProps<{
  show: boolean
}>()
defineEmits(['hide'])

const { openTonkeeperInStore } = useDailyTransactionTask()
</script>

<template>
  <TheBottomSheet
    :show="show"
    centered
    @hide="$emit('hide')"
  >
    <div class="text-center text-red-accent text-[24px] leading-8 font-bold">
      <T
        key-name="lingo.giveaway.transaction.failed_title"
        default-value="Transaction has failed"
      />
    </div>
    <div
      class="mt-2 mx-auto max-w-[315px] text-center text-white/60 text-base font-medium"
    >
      If you’re using Telegram Wallet, we recommend switching to
      <BaseLinkButton
        @click="openTonkeeperInStore"
      >
        Tonkeeper
      </BaseLinkButton>
      for a smoother experience.
    </div>
    <div class="w-full mt-6">
      <ConnectedWallet
        :short-button="false"
        :confirm-disconnect="false"
        @disconnect-done="$emit('hide')"
      />
    </div>
  </TheBottomSheet>
</template>

<style scoped>

</style>